// extracted by mini-css-extract-plugin
export default {"sliderContainer":"yyn6b___Triptych-module__sliderContainer"};